import React from "react";
import { Link, graphql, useStaticQuery } from "gatsby";
import MdsSection from "../utilities/MdsSection";
import MdsRow from "../utilities/MdsRow";
import MdsCol from "../utilities/MdsCol";
import ProjectsGrid from "../blocks/ProjectsGrid";
import MotionSingle from "../utilities/Motion/MotionSingle";

const FeaturedProjects = ({ slice, context }) => {
  const allFeaturedProjects = useStaticQuery(graphql`
    query HeaderQuery {
      greekProjects: allPrismicProjects(
        filter: { lang: { eq: "el-gr" }, data: { featured: { eq: true } } }
        sort: { last_publication_date: DESC }
        limit: 6
      ) {
        nodes {
          data {
            featured_image {
              gatsbyImageData(layout: FULL_WIDTH)
            }
            secondary_image {
              alt
              dimensions {
                height
                width
              }
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
            title
            region
            body {
              ... on PrismicProjectsDataBodySingleImage {
                id
                slice_label
                primary {
                  image {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
                slice_type
              }
              ... on PrismicProjectsDataBodyTwoImages {
                slice_label
                slice_type
                primary {
                  image_1 {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                  image_2 {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
              }
            }
          }
          url
        }
      }
      englishProjects: allPrismicProjects(
        filter: { lang: { eq: "en-us" }, data: { featured: { eq: true } } }
        sort: { last_publication_date: DESC }
        limit: 6
      ) {
        nodes {
          data {
            featured_image {
              gatsbyImageData(layout: FULL_WIDTH)
            }
            secondary_image {
              alt
              dimensions {
                height
                width
              }
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
            title
            region
            body {
              ... on PrismicProjectsDataBodySingleImage {
                id
                slice_label
                primary {
                  image {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
                slice_type
              }
              ... on PrismicProjectsDataBodyTwoImages {
                slice_label
                slice_type
                primary {
                  image_1 {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                  image_2 {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
              }
            }
          }
          url
        }
      }
      dutchProjects: allPrismicProjects(
        filter: { lang: { eq: "de-de" }, data: { featured: { eq: true } } }
        sort: { last_publication_date: DESC }
        limit: 6
      ) {
        nodes {
          data {
            featured_image {
              gatsbyImageData(layout: FULL_WIDTH)
            }
            secondary_image {
              alt
              dimensions {
                height
                width
              }
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            }
            title
            region
            body {
              ... on PrismicProjectsDataBodySingleImage {
                id
                slice_label
                primary {
                  image {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
                slice_type
              }
              ... on PrismicProjectsDataBodyTwoImages {
                slice_label
                slice_type
                primary {
                  image_1 {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                  image_2 {
                    alt
                    dimensions {
                      height
                      width
                    }
                    gatsbyImageData(placeholder: BLURRED)
                  }
                }
              }
            }
          }
          url
        }
      }
    }
  `);

  let featuredProjects;

  if (context?.page?.lang === "el-gr") {
    featuredProjects = allFeaturedProjects?.greekProjects?.nodes;
  } else if (context?.page?.lang === "en-us") {
    featuredProjects = allFeaturedProjects?.englishProjects?.nodes;
  } else {
    featuredProjects = allFeaturedProjects?.dutchProjects?.nodes;
  }

  const {
    primary: { label, link, title },
  } = slice;

  return (
    <MdsSection>
      <MdsRow>
        <MdsCol md={2}>
          <div className="flex md:flex-col max-md:justify-between pt-x2 gap-y-x4s">
            <div className="overflow-hidden">
              <MotionSingle offsetY={0} offsetX="-100%" margin="-100px">
                <h3 className="font-[300] h4">{title}</h3>
              </MotionSingle>
            </div>
            <div className="overflow-hidden">
              <MotionSingle offsetY={0} offsetX={-50} margin="-100px">
                <Link
                  className="yellow-square-before md:translate-x-[24px]"
                  to={link?.url}
                >
                  {label}
                </Link>
              </MotionSingle>
            </div>
          </div>
        </MdsCol>
        <MdsCol md={10}>
          <ProjectsGrid
            bigCardInterval={0}
            projects={featuredProjects}
            grayBgCards={false}
          />
        </MdsCol>
      </MdsRow>
    </MdsSection>
  );
};

export default FeaturedProjects;
